export default __webpack_public_path__ + "static/media/empty-big.53ef7af3.svg";